import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Search-and-pick a customer to receive a store-credit refund.
export const CreditCustomerPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return undefined; }
    const t = setTimeout(async () => {
      const { data } = await api.get("/customers", { params: { q: q.trim(), limit: 6 } });
      setResults(data || []);
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2" data-testid="credit-customer-selected">
        <div className="text-[13px] font-semibold text-emerald-900">{value.name}<span className="ml-2 font-normal text-emerald-700">{value.phone}</span></div>
        <button type="button" onClick={() => onChange(null)} className="text-[11px] font-semibold text-emerald-800 underline" data-testid="credit-customer-change">Change</button>
      </div>
    );
  }
  return (
    <div>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search customer by name or phone…"
        className="w-full h-10 px-3 rounded-xl border border-slate-200 focus:border-emerald-500 focus:outline-none text-[13px]"
        data-testid="credit-customer-search"
      />
      {results.length > 0 && (
        <div className="mt-1 rounded-xl border border-slate-200 divide-y max-h-40 overflow-y-auto">
          {results.map((c) => (
            <button key={c.id} type="button" onClick={() => onChange(c)} className="w-full text-left px-3 py-2 hover:bg-slate-50 text-[13px]" data-testid={`credit-customer-option-${c.id}`}>
              <span className="font-semibold">{c.name}</span> <span className="text-slate-500">{c.phone}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
